import styled from "styled-components";
import { Box } from "../Box";
export const Wrapper = styled(Box)(({ theme: { borders, radii, space, colors: { deprecatedSearchBoxColors }, }, }) => ({
    alignItems: "center",
    backgroundColor: deprecatedSearchBoxColors.wrapperBackground,
    border: borders[1],
    borderColor: deprecatedSearchBoxColors.wrapperBorder,
    borderRadius: radii[1],
    display: "flex",
    flexWrap: "wrap",
    marginRight: space[1],
    paddingLeft: space[1],
    paddingRight: space[1],
    position: "relative",
    width: "100%",
}));
